import React, { useState } from "react";
import "./ForwardModal.css";
import moment from "moment";

const $ = window.$;

function ForwardFilterModal({ onClose, openForward, openForwardMultiple, setGroupFilter, openNextModal }) {
  
  const [group, setGroup] = useState('');

  const handleChange = (group) => {
    setGroupFilter(group);
    setGroup(group);
  }
  
  const handleSetReminder = () => {
    if (openNextModal === 'forward') {
      openForward();
      // onClose(false);
    } else {
      openForwardMultiple(); // <<< check param
      // onClose(false)
    }
  }

  return (
    <div className="assignment-notify-container">
      <div className="selection-container">
        <div className="save-changes-flex" style={{ marginLeft: 5 }}>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
          <i className="fas fa-exclamation-circle hc-primary-text fa-1x"></i>

            <h6>Select Group</h6>
            <i className="fas fa-times" type="button" style={{float:'right'}} onClick={() => onClose(false)} />
          </div>
        </div>
          <div className="radio selection-table text-lg">
            <span>
              <input 
                id="contact"
                type="radio" 
                value="hour" 
                name="reminder"
                onChange={(e) => handleChange('contact')} 
                /> <label htmlFor="contact"> Contact</label> 
            </span>
            <></>
            <span>
              <input 
                id="group"
                type="radio" 
                value="day" 
                name="reminder"
                onChange={(e) => handleChange('group')} 
                /> <label htmlFor="group"> Group</label>
              </span>
            <span className="text-sm">
            </span>
            <span>
            <input 
              id="patient"
              type="radio" 
              value="week" 
              name="reminder" 
              onChange={(e) => handleChange('patient')} 
              /> <label htmlFor="patient"> Patient</label> 
            </span>
            <></>
          </div>
          <div style={{ textAlign: "right", marginTop: 10 }}>
            <button
              type="button"
              disabled={group === '' ? true : false}
              style={{ marginRight: "10px" }}
              className="btn btn-hubchart btn-hubchart-primary"
              onClick={handleSetReminder}
            >
              Proceed
            </button>
          </div>
      </div>
    </div>
  );
}

export default ForwardFilterModal;
